var _path, _ellipse, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 246,
    viewBox: "0 0 283 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.557 55.8354V0L0.114746 245.337H33.0198L141.557 55.8354ZM141.557 55.8354V0L283 245.337H250.095L141.557 55.8354Z",
    fill: "url(#paint0_linear_283_3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.558,
    cy: 154.566,
    rx: 31.3507,
    ry: 31.7152,
    fill: "url(#paint1_linear_283_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.516 207.315L122.237 191.02L32.9238 245.337L54.516 207.315Z",
    fill: "url(#paint2_linear_283_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.578 207.307L157.597 191.749L250.191 245.337L228.578 207.307Z",
    fill: "url(#paint3_linear_283_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_3",
    x1: 142,
    y1: 226.5,
    x2: 141.758,
    y2: 23.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFDEC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#FDCBA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FFE7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_283_3",
    x1: 141.558,
    y1: 122.851,
    x2: 141.558,
    y2: 189.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#FFD9BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FFCBA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC093"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_283_3",
    x1: 37.095,
    y1: 226.573,
    x2: 114.438,
    y2: 245.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#FFDDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_283_3",
    x1: 246.016,
    y1: 226.569,
    x2: 168.604,
    y2: 245.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#FFDDC5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ef786e0e2f2eae8f341704e35c220826.svg";
export { ForwardRef as ReactComponent };